const dateKey = (value) => String(value || '').slice(0, 10);

const startOfDay = (value = new Date()) => new Date(value.getFullYear(), value.getMonth(), value.getDate());

const expandDateRange = (startValue, endValue) => {
  const start = dateKey(startValue);
  const end = dateKey(endValue || startValue);
  if (!start || !end) return [];
  const cursor = new Date(`${start}T00:00:00`);
  const last = new Date(`${end}T00:00:00`);
  const dates = [];
  while (!Number.isNaN(cursor.getTime()) && cursor <= last) {
    dates.push(`${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}-${String(cursor.getDate()).padStart(2, '0')}`);
    cursor.setDate(cursor.getDate() + 1);
  }
  return dates;
};

export const filterOverviewSchedulePeriod = (schedules = [], period = 'today', now = new Date()) => {
  const today = startOfDay(now);
  const end = new Date(today);
  if (period === 'week') end.setDate(today.getDate() + 6);
  if (period === 'month') end.setMonth(today.getMonth() + 1, 0);
  return (Array.isArray(schedules) ? schedules : [])
    .filter((schedule) => {
      const date = new Date(`${dateKey(schedule?.startDate)}T00:00:00`);
      return !Number.isNaN(date.getTime()) && date >= today && date <= end;
    })
    .sort((a, b) => dateKey(a.startDate).localeCompare(dateKey(b.startDate)) || String(a.title || a.companyName || '').localeCompare(String(b.title || b.companyName || '')));
};

export const includeSalesOwnedAuditSchedules = (schedules = [], tasks = [], username = '') => {
  const taskRows = Array.isArray(tasks) ? tasks : [];
  const matchingOwnerRows = taskRows.filter((task) => String(task?.salesOwnerUsername || '').toLowerCase() === String(username || '').toLowerCase());
  const ownedRows = matchingOwnerRows.length > 0 ? matchingOwnerRows : taskRows;
  const ownedProjectIds = new Set(ownedRows
    .map((task) => String(task?.projectId || '')));
  return (Array.isArray(schedules) ? schedules : []).filter((schedule) => (
    schedule?.scheduleKind !== 'audit' || ownedProjectIds.has(String(schedule?.projectId || ''))
  ));
};

export const flattenSalesProjectAuditSchedules = (projectResponses = []) => (Array.isArray(projectResponses) ? projectResponses : []).flatMap((project) => (
  (Array.isArray(project?.payload?.schedules) ? project.payload.schedules : []).flatMap((scope) => (
    (Array.isArray(scope?.auditSchedules) ? scope.auditSchedules : []).flatMap((schedule, scheduleIndex) => {
      const dates = Array.isArray(schedule?.mandayDetails) && schedule.mandayDetails.length
        ? schedule.mandayDetails.map((row) => dateKey(row?.date)).filter(Boolean)
        : expandDateRange(schedule?.startDate, schedule?.endDate);
      return dates.map((startDate, dateIndex) => ({
        ...schedule,
        id: `owned-audit-${schedule?.id || `${scope?.id || 'scope'}-${scheduleIndex}`}-${dateIndex}`,
        startDate,
        projectId: project.projectId,
        projectCode: project.projectCode,
        companyName: project.companyName,
        scheduleKind: 'audit',
        typeLabel: 'Audit',
      }));
    })
  ))
));

export const mergeUniqueSchedules = (schedules = []) => {
  const rows = new Map();
  (Array.isArray(schedules) ? schedules : []).forEach((schedule) => {
    const key = [schedule?.scheduleKind, schedule?.projectId, dateKey(schedule?.startDate), schedule?.employeeId || schedule?.employeeName, schedule?.title || schedule?.auditType].join('|');
    if (!rows.has(key)) rows.set(key, schedule);
  });
  return [...rows.values()];
};
